module.exports = __webpack_public_path__ + "img/SMSC81916-min.144d7fec.png";